import axios from "axios";
import { store } from "../redux/store";

import ENV from "../redux/config/env";

const axiosInstance = axios.create({
  baseURL: ENV.API_BASE_URL,
});

let isSessionExpired = false;

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      if (!isSessionExpired) {
        isSessionExpired = true;

        store.dispatch({ type: "SESSION_EXPIRED" });
        window.dispatchEvent(new CustomEvent("FORCE_LOGOUT"));
      }
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);


export default axiosInstance;
